import SaleItemData from "../../data/SaleItemData";
import {Component} from "react";
import React from "react";
import {FormattedNumber} from "react-intl";
import {Button, Form, Grid, Icon, Label, List, Modal, Statistic, Table, TextArea} from "semantic-ui-react";
import {connect} from "react-redux";
import localDB from "../../data/localDB";
import {updateQuantity, removeProduct} from "../../actions/ProductsSaleActions";
import QuestionDialog from "../extras/QuestionDialog";
import {totalSale} from "../../actions/SaleTotalAction";
import {showToast} from "../../actions/ToastAction";
import CustomDivider from "../extras/CustomDivider";

export class ProductSaleRow extends Component {

    constructor(props) {
        super(props);
        this.state = {
            minus_active: false,
            plus_active: false,
            observation: props.product_sale.observation,
            message_product: false,
            quantity: props.product_sale.quantity,
            discount_percentage: props.product_sale.discount,
            discount_observations: props.product_sale.discount_observations,
            discount_money: (this.props.product_sale.price * this.props.product_sale.quantity) - ((this.props.product_sale.price * this.props.product_sale.quantity) * (this.props.product_sale.discount / 100)),
            sending: false,
            updating_quantity: false,
            modal_discount: false,
            modal_quantity: false
        };
        this.updateQuantity = this.updateQuantity.bind(this);
        this.handleDeleteItem = this.handleDeleteItem.bind(this);
        this.handleOpenObservation = this.handleOpenObservation.bind(this);
        this.handleObservationChange = this.handleObservationChange.bind(this);
        this.updateObservation = this.updateObservation.bind(this);
        this.handleOpenDiscount = this.handleOpenDiscount.bind(this);
        this.handleDiscountPercentageChange = this.handleDiscountPercentageChange.bind(this);
        this.updateDiscount = this.updateDiscount.bind(this);
        this.handleDiscountObservationChange = this.handleDiscountObservationChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChangeQuantityProduct = (quantity) => {
        if(this.props.order_state === 1) {
            let item_quantity = this.props.product_sale.quantity + (quantity*-1);
            if (item_quantity > 0) {
                if (quantity < 0) {
                    this.setState({plus_active: true});
                } else {
                    this.setState({minus_active: true});
                }
                this.updateQuantity(item_quantity, quantity)
            }
        }
    };

    updateQuantity(quantity, new_quantity, bulk_update=false) {
        let data = {}
        if(this.props.order_state === 1) {
            if(bulk_update){
                data = {
                    id: this.props.product_sale.id,
                    product: this.props.product_sale.product.id,
                    quantity,
                    sale: this.props.sale_id,
                    bulk_update,
                    variants: null
                };
            }else{
                data = {
                    id: this.props.product_sale.id,
                    product: this.props.product_sale.product.id,
                    quantity: new_quantity,
                    sale: this.props.sale_id,
                    variants: null
                };
            }

            SaleItemData.update(data, (res) => {
                if (res !==null && res.update) {
                    data.quantity = quantity - this.props.product_sale.quantity;
                    this.setState({quantity: res.data.quantity});
                    this.props.updateQuantity(data);
                    this.props.totalSale(res.total);
                } else {
                    this.props.showToast({message: res ? res.message:'Tenemos un problema!', type: 'error'});
                }
                this.setState({minus_active: false, plus_active:false});
            }).finally(()=>{
                if(bulk_update){
                    this.setState({updating_quantity: false})
                    this.toggleModal()
                }
            });
        }
    };

    handleDeleteItem() {
        if(this.props.order_state === 1) {
            this.setState({sending: true});
            SaleItemData.delete(this.props.product_sale.id, (res) => {
                if(res.delete){
                    this.props.removeProduct(this.props.product_sale.id);
                    this.props.totalSale(res.total);
                }else{
                    this.props.showToast({message: 'Venta cerrada!', type: 'error'});
                }
                this.setState({sending: false});
            });
        }
    };

    handleOpenObservation() {
        this.setState({message_product: true});
    };

    handleOpenDiscount() {
        this.setState({modal_discount: true});
    };

    handleObservationChange = (event) => {
        let observation = event.target.value;
        this.setState({observation});
    };

    handleDiscountObservationChange = (event) => {
        let discount_observations = event.target.value;
        this.setState({discount_observations});
    };

    async updateObservation() {
        let observation = this.state.observation;
        if (observation !== '') {
            let data = {observation: observation, id: this.props.product_sale.id};
            this.setState({state_button_observation: true});
            SaleItemData.updateObservation(data, (res) => {
                if (res.update) {
                    this.props.product_sale.observation = observation
                    this.setState({message_product: false})
                } else {
                    this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                }
                this.setState({state_button_observation: false});
            });
        }
    }

    updateDiscount() {
        let discount = this.state.discount_percentage;
        if (discount !== '') {
            let data = {discount, discount_observations:this.state.discount_observations, id: this.props.product_sale.id};
            this.setState({state_button_observation: true});
            SaleItemData.updateDiscount(data, (res) => {
                if (res.update) {
                    this.props.totalSale(res.total);
                    this.setState({modal_discount: false})
                    this.props.showToast({message: 'Descuento aplicado!', type: 'success'});
                } else {
                    this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                }
                this.setState({state_button_observation: false});
            });
        }
    }

    handleDiscountPercentageChange = (event) => {
        let value = event.target.value
        let discount_percentage = parseFloat(value);
        if (discount_percentage >= 0) {
            let discount_money = (this.props.product_sale.price*this.props.product_sale.quantity) - (discount_percentage * (this.props.product_sale.price*this.props.product_sale.quantity)) / 100;
            this.setState({ discount_percentage, discount_money, discount_error: false, disabled:false});
        } else {
            this.setState({discount_error: true, disabled:true});
        }
        if (discount_percentage > 100){
            this.setState({disabled:true});
        }
        if (event.target.value.trim() === '' || isNaN(discount_percentage)){
            this.setState({ discount_error: true, disabled: true, discount_percentage: '', discount_money: this.props.product_sale.price*this.props.product_sale.quantity});
        }
    };

    toggleModal = () => {
        this.setState({modal_quantity: !this.state.modal_quantity})
    }

    handleSubmitQuantity = () => {
        if(this.state.quantity > 0){
            this.setState({updating_quantity: true})
            this.updateQuantity(parseInt(this.state.quantity), 0, true)
        }
    }

    handleChange = (e, { name, value }) => this.setState({ [name]: value })

    render() {
        return (
            <Table.Row>
                {
                    this.props.order_state === 1 && (!this.props.product_sale.locked || localDB.get('store_security').can_add_sale_item) ? <Table.Cell>
                        <Button.Group size='small'>
                            <Button icon='minus' loading={this.state.minus_active} disabled={this.state.minus_active}
                                    onClick={() => this.handleChangeQuantityProduct(1)}/>
                            <Button content={this.props.product_sale.quantity} active onClick={this.toggleModal}/>
                            <Button icon='plus' loading={this.state.plus_active} disabled={this.state.plus_active}
                                    onClick={() => this.handleChangeQuantityProduct(-1)}/>
                        </Button.Group>
                    </Table.Cell>: <Table.Cell textAlign='center'>{this.props.product_sale.quantity}</Table.Cell>
                }
                <Table.Cell>
                    {this.props.product_sale.product.name}
                    {this.props.product_sale.variant ? <List.Description>{this.props.product_sale.variant.name}</List.Description>:null}
                    {this.props.product_sale.products_variants.length > 0 ? <React.Fragment>
                        <List>
                        {this.props.product_sale.products_variants.map((product_variant) => <List.Item>
                            <List.Icon name='food' />
                            <List.Content>
                                <List.Header>{product_variant.product.name}</List.Header>
                                <List.Description>{product_variant.variant.name}</List.Description>
                            </List.Content>
                        </List.Item>)}
                        </List>
                    </React.Fragment>:null}
                    {this.props.product_sale.observation ? <p>
                        <Label as='a' color='orange' onClick={this.handleOpenObservation}><Icon name='sticky note' /> {this.props.product_sale.observation}</Label>
                    </p>:null}
                    {this.props.product_sale.get_without_compounds ? <List>
                        {this.props.product_sale.get_without_compounds.map((compound) => <List.Item>
                            <List.Icon name='remove' />
                            <List.Content>
                                <List.Header>SIN {compound['name']}</List.Header>
                            </List.Content>
                        </List.Item>)}
                    </List>:null}
                </Table.Cell>
                <Table.Cell>
                    $<FormattedNumber value={this.props.product_sale.price / ((this.props.product_sale.percentage/100)+1)} currency="USD" maximumFractionDigits={1}
                                      minimumFractionDigits={0}/>
                </Table.Cell>
                <Table.Cell>
                    {this.props.product_sale.percentage}%
                </Table.Cell>
                <Table.Cell>
                    $<FormattedNumber
                    value={this.props.product_sale.price * this.props.product_sale.quantity}
                    currency="USD" maximumFractionDigits={0} minimumFractionDigits={0}/>
                </Table.Cell>
                <Table.Cell>
                    <Button.Group size='small'>
                        {
                            this.props.order_state === 1 && (!this.props.product_sale.locked || localDB.get('store_security').can_add_sale_item) ?
                                <Button icon='trash' loading={this.state.sending}
                                        disabled={this.state.sending}
                                        onClick={() => this.refs.question_dialog.open('Quitar este producto', 0)}
                                /> : null
                        }
                        {!this.props.product_sale.locked || localDB.get('store_security').can_add_sale_item ? <Button icon='sticky note' onClick={this.handleOpenObservation}/>:null}
                        {localDB.check_feature('sale_item_discount') ? <Button icon='tags' onClick={this.handleOpenDiscount}/>:null}
                    </Button.Group>

                    <Modal open={this.state.message_product} dimmer='inverted' size='tiny'
                           onClose={() => this.setState({message_product: false})}>
                        <Modal.Header>Observaciones</Modal.Header>
                        <Modal.Content>
                            <Modal.Description>
                                <Form>
                                <TextArea rel='text_observation' placeholder='¿Alguna observación para este producto?'
                                          value={this.state.observation} onChange={this.handleObservationChange}/>
                                </Form>
                            </Modal.Description>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button icon='x' labelPosition='left'
                                    onClick={() => this.setState({message_product: false})}
                                    content="Cancelar"/>
                            <Button primary icon='save' labelPosition='left'
                                    disabled={this.state.state_button_observation}
                                    loading={this.state.state_button_observation} onClick={this.updateObservation}
                                    content='Guardar'/>
                        </Modal.Actions>
                    </Modal>
                    <Modal open={this.state.modal_discount} dimmer='inverted' size='tiny' onClose={() => this.setState({modal_discount: false})}>
                        <Modal.Header>Descuento</Modal.Header>
                        <Modal.Content>
                            <Modal.Description>
                                <Statistic.Group widths={2} size='tiny'>
                                    <Statistic>
                                        <Statistic.Value>
                                            $<FormattedNumber
                                            value={this.props.product_sale.price * this.props.product_sale.quantity}
                                            currency="USD" maximumFractionDigits={0} minimumFractionDigits={0}/>
                                        </Statistic.Value>
                                        <Statistic.Label>Total</Statistic.Label>
                                    </Statistic>
                                    <Statistic>
                                        <Statistic.Value>
                                            $<FormattedNumber
                                            value={this.state.discount_money}
                                            currency="USD" maximumFractionDigits={0} minimumFractionDigits={0}/>
                                        </Statistic.Value>
                                        <Statistic.Label>Total con descuento</Statistic.Label>
                                    </Statistic>
                                </Statistic.Group>
                                <CustomDivider />
                                <Form>
                                    <Form.Input
                                        fluid
                                        label="Descuento en %"
                                        placeholder='Descuento en %'
                                        value={this.state.discount_percentage}
                                        onChange={this.handleDiscountPercentageChange}
                                        type='number'
                                        error={this.state.discount_percentage > 100}
                                    />
                                    <Form.TextArea rel='text_observation' placeholder='¿Alguna observación para este producto?' value={this.state.discount_observations} onChange={this.handleDiscountObservationChange}/>
                                </Form>
                            </Modal.Description>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button icon='x' labelPosition='left'
                                    onClick={() => this.setState({modal_discount: false})}
                                    content="Cancelar"/>
                            <Button primary icon='save' labelPosition='left'
                                    disabled={this.state.state_button_observation}
                                    loading={this.state.state_button_observation} onClick={this.updateDiscount}
                                    content='Guardar'/>
                        </Modal.Actions>
                    </Modal>
                </Table.Cell>
                <QuestionDialog ref='question_dialog' callbackConfirm={this.handleDeleteItem} message="Borrar este producto"/>
                <Modal open={this.state.modal_quantity} size='mini' dimmer='inverted'>
                    <Modal.Header>Actualizar Cantidad</Modal.Header>
                    <Modal.Content image>
                        <Modal.Description>
                            <Form>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column>
                                            <Form.Input
                                                label='Cantidad'
                                                name='quantity'
                                                type='number'
                                                error={this.state.quantity <= 0}
                                                value={this.state.quantity}
                                                onChange={this.handleChange}
                                            />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.toggleModal} content="Cancelar"/>
                        <Button primary icon='save' disabled={this.state.updating_quantity} loading={this.state.updating_quantity} labelPosition='left' content='Guardar' onClick={this.handleSubmitQuantity}/>
                    </Modal.Actions>
                </Modal>
            </Table.Row>
        )
    }
}

function mapStateToProps(state, props) {
    return {
        product_sale: state.get('products_sale').filter(product => {
            return product.id === props.id
        })[0],
    };
}

function mapDispatchToProps(dispatch) {
    return {
        updateQuantity(product) {
            dispatch(updateQuantity(product));
        },
        removeProduct(product) {
            dispatch(removeProduct(product));
        },
        totalSale(total) {
            dispatch(totalSale(total))
        },
        showToast(data) {
            dispatch(showToast(data));
        }
    }
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductSaleRow)



// WEBPACK FOOTER //
// ./src/components/sale/ProductSaleRow.js